import Shipping from "./shipping/shipping.vue";
import AddCardInfo from "./addCardInfo/addCardInfo.vue";
import OrderReview from "./orderReview/orderReview.vue";
import CheckoutSidebar from "./checkoutSidebar/checkoutSidebar.vue";

export default {
  components: {
    Shipping,
    AddCardInfo,
    OrderReview,
    CheckoutSidebar,
  },

  data() {
    return {
      checkoutSteps: [
        {
          name: null,
          label: "Your Cart",
        },
        {
          name: "checkoutShipping",
          label: "Shipping & Billing",
        },
        {
          name: "checkoutOrderReview",
          label: "Order Review",
        },
        {
          name: "checkoutAddCardInfo",
          label: "Payment",
        },
      ],
      hasChosenNet0: false,
    };
  },

  methods: {
    back,
    handleNet0ChoiceChange,
  },
};

function back() {
  this.$router.push("/checkout");
}

function handleNet0ChoiceChange(val) {
  this.hasChosenNet0 = val;
}
